/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Account_Error_SuspendedInputs */

const en_lib_account_error_suspended = /** @type {(inputs: Lib_Account_Error_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account has been suspended`)
};

/**
* | output |
* | --- |
* | "Account has been suspended" |
*
* @param {Lib_Account_Error_SuspendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_account_error_suspended = /** @type {((inputs?: Lib_Account_Error_SuspendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Account_Error_SuspendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_account_error_suspended(inputs)
});
export { lib_account_error_suspended as "lib.account.error.suspended" }